export const mobileMenu = () => {
  const headerElement = document.querySelector(
    "[data-js-menu=hide-on-scroll]"
  ) as HTMLElement;

  const closePanel = (panel: HTMLElement, interactive = true) => {
    panel.style.transform = "";
    panel.style.opacity = "";
    const link = panel.previousElementSibling as HTMLElement;
    link?.setAttribute("aria-expanded", "false");
    if (interactive) {
      link?.focus();
      setTimeout(() => (panel.style.visibility = "collapse"), 200);
    } else {
      panel.style.visibility = "collapse";
    }
  };

  const closeAllPanels = (mobileMenu: HTMLElement) => {
    mobileMenu
      .querySelectorAll("[data-js-menu=mobile-panel]")
      .forEach(panel => closePanel(panel as HTMLElement, false));
  };

  const openPanel = (panel: HTMLElement) => {
    const link = panel.previousElementSibling as HTMLElement;
    link?.setAttribute("aria-expanded", "true");
    panel.style.visibility = "visible";
    panel.style.transform = "translateX(0)";
    panel.style.opacity = "1";
  };

  const closeMobileMenu = (mobileMenu: HTMLElement) => {
    mobileMenu.style.display = "none";
    closeAllPanels(mobileMenu);
  };

  const openMobileMenu = (mobileMenu: HTMLElement) => {
    mobileMenu.style.display = "flex";
  };

  const toggleMobileMenuHandler = (e: Event) => {
    const btn = e.currentTarget as HTMLElement;
    const wasOpen: boolean = btn.getAttribute("aria-expanded") === "true";
    const mobileMenuId = btn.getAttribute("aria-controls");
    if (!mobileMenuId) {
      console.error("Missing id in aria-controls attribute of toggle button");
      return;
    }

    const mobileMenu = document.getElementById(mobileMenuId);
    if (!mobileMenu) {
      console.error(`Could not find mobile menu: ${mobileMenuId}`);
      return;
    }

    wasOpen ? closeMobileMenu(mobileMenu) : openMobileMenu(mobileMenu);
    btn.setAttribute("aria-expanded", (!wasOpen).toString().toLowerCase());
    btn
      .querySelectorAll("[data-js-menu=toggle-icon]")
      .forEach(icon => icon.classList.toggle("hidden"));

    if (headerElement) {
      // shared state with scrollEffect
      headerElement.dataset.mobileMenuOpen = wasOpen ? "false" : "true";
    }
  };

  const showPanelHandler = (e: Event) => {
    const link = e.currentTarget as HTMLElement;
    const panel = link.nextElementSibling as HTMLElement;
    if (panel) {
      // open panel instead of link
      e.preventDefault();
      openPanel(panel);
    }
  };

  const hidePanelHandler = (e: Event) => {
    const panel = (e.currentTarget as HTMLElement)?.closest(
      "[data-js-menu=mobile-panel]"
    ) as HTMLElement;
    if (panel) {
      closePanel(panel);
    }
  };

  const closeMobileMenuOnEscapeHandler = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      const toggleButton = document.querySelector(
        "[data-js-menu=toggle-button]"
      ) as HTMLElement;
      if (toggleButton?.getAttribute("aria-expanded") === "true") {
        toggleButton.click();
      }
    }
  };

  // Bind mobile menu events

  document
    .querySelectorAll("[data-js-menu=toggle-button]")
    .forEach(btn => btn.addEventListener("click", toggleMobileMenuHandler));

  document
    .querySelectorAll("[data-js-menu=mobile-item]")
    .forEach(link => link.addEventListener("click", showPanelHandler));

  document
    .querySelectorAll("[data-js-menu=back-button]")
    .forEach(btn => btn.addEventListener("click", hidePanelHandler));

  document.addEventListener("keydown", e =>
    closeMobileMenuOnEscapeHandler(e as KeyboardEvent)
  );
};
